import { Typography, TypographyProps } from '@mui/material';

/**
 * Typography component for secondary text in menu items, ensuring consistent styling
 * for secondary/helper text in dropdown and select options throughout the app.
 * Use this for rendering secondary descriptive text below the main option text.
 */
export function MenuItemSecondaryTypography(props: Partial<TypographyProps>) {
  return <Typography variant="body-xs" {...props} />;
}
